import React, { Suspense } from 'react';
import './App.module.scss';
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Lazy loading ile BaseLayout'ları yükle
const BaseLayout = React.lazy(() => import("./components/BaseLayout"));
const BaseLayoutEn = React.lazy(() => import("./components/BaseLayoutEn"));

function App() {
   return (
      <div>
         <BrowserRouter>
            <Suspense fallback={
               <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100vh',
                  fontSize: '18px'
               }}>
                  Yükleniyor...
               </div>
            }>
               <Routes>
                  {/* İngilizce rotalar */}
                  <Route path="/en/*" element={<BaseLayoutEn />} />
                  {/* Türkçe rotalar (varsayılan) */}
                  <Route path="/*" element={<BaseLayout />} />
               </Routes>
            </Suspense>
         </BrowserRouter>
      </div>
   );
}


export default App;
